const PRODUCT_QUANTITIES_DOMAIN = 'productQuantities'
const PRODUCT_QUANTITIES_STATE = {
  all: {
    data: [],
    status: null
  },
  data: {}
}

export {
  PRODUCT_QUANTITIES_DOMAIN,
  PRODUCT_QUANTITIES_STATE
}
